import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { throttle, scheduleOnce } from '@ember/runloop';
import AnalyticsService from 'cio/services/analytics';
import IntegrationModel from 'cio/models/integration';
import CrumbsService from 'cio/services/crumbs';
import WindowMessengerService from 'cio/services/window-messenger';
import { IntegrationType } from 'cio/utils/integrations/static-integrations';

export default class IntegrationPublicTypeController extends Controller {
  @service analytics!: AnalyticsService;
  @service crumbs!: CrumbsService;
  @service windowMessenger!: WindowMessengerService;

  model!: IntegrationModel;
  public = true;
  showNotify = false;

  queryParams = ['showNotify'];

  get isConnectPartners() {
    return this.model.type === IntegrationType.connectPartner;
  }

  @action
  trackClick(evt: MouseEvent) {
    // UseCases come from the spreadsheet, and some may include URLs in each `li`. In the model, we
    // parse out those URLs and turn them into `a` tags, and them insert them with the `url-safe`
    // helper. At the same time, we want to track when one of those links are clicked via mixpanel.
    // Thus, here, we leverage event bubbling and catch the click on the nearest parent, the `li`,
    // and execute a mixpanel event if they clicked on the `a` tag only.
    if ((evt.target as HTMLElement)?.tagName !== 'A') {
      return;
    }

    let anchor = evt.target as HTMLAnchorElement;
    let href = anchor.getAttribute('href');

    this.analytics.track('integration', 'use_case_link_clicked', {
      from: 'Public',
      category: this.model.category,
      name: this.model.name,
      type: this.model.type,
      url: href!,
    });
  }

  @action
  handleResize() {
    throttle(this, this.sendNewSize, 100);
  }

  @action
  sendNewSize() {
    scheduleOnce('afterRender', this.windowMessenger, () => {
      this.windowMessenger.send('resize', {
        height: document.querySelector('.external-integration--public')?.clientHeight,
      });
    });
  }
}
